// 添加或者编辑品牌校验
export const addOrEditBrandRules = {
  brandName: [
    { required: true, message: '请输入品牌名称', trigger: 'blur' }
  ]
}
// 添加或者编辑系列校验
export const addOrEditSeriesRules = {
  brandId: [
    { required: true, message: '品牌名称不能为空', trigger: 'change' }
  ],
  seriesName: [
    { required: true, message: '请输入系列名称', trigger: 'blur' }
  ]
}
// 添加产品和产品编辑详情校验
export const productAddOrEditRules = {
  pcId: [// 品类
    { required: true, message: '请选择品类', trigger: 'change' }
  ],
  brandId: [// 品牌
    { required: true, message: '请选择品牌', trigger: 'change' }
  ],
  brandSid: [// 系列
    { required: true, message: '请选择系列', trigger: 'change' }
  ],
  proName: [// 产品名称
    { required: true, message: '请输入产品名称', trigger: 'blur' }
  ],
  proModel: [// 型号
    { required: true, message: '请输入型号', trigger: 'blur' }
  ],
  proUnit: [// 最小单位
    { required: true, message: '请选择最小单位', trigger: 'change' }
  ],
  proOutunit: [// 出货单位
    { required: true, message: '请选择出货单位', trigger: 'change' }
  ],
  proPrice: [// 产品面价
    { required: true, message: '请输入产品面价', trigger: 'blur' }
  ]
}
// 添加参数校验
export const addParameterRules = {
  paramName: [// 参数名称
    { required: true, message: '请输入参数名称', trigger: 'blur' }
  ],
  productClassParamValue: [// 参数值
    { required: true, message: '请输入参数值', trigger: 'blur' }
  ]
}
// 添加分类校验
export const addOrEditClassRules = {
  pcName: [// 分类名称
    { required: true, message: '请输入分类名称', trigger: 'blur' }
  ],
  taxpoint: [// 税收数值
    { required: true, message: '请输入税收数值', trigger: 'blur' }
  ]
}
// 初始系数设置
export const initialSettingRules = {
  allCoefficient: [// 全品类初始系数
    { required: true, message: '请输入全品类初始系数', trigger: 'blur' }
  ],
  tempCoefficient: [// 临时产品系数
    { required: true, message: '请输入临时产品系数', trigger: 'blur' }
  ]
}
